const normalizeCategoryBase = (value) => {
  return String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/\//g, ' ')
    .replace(/[^a-z0-9\s-]/g, ' ')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .replace(/-gibraltar$/, '');
};

export const categoryNameToSeoSlug = (categoryName) => {
  const base = normalizeCategoryBase(categoryName);
  if (!base) return 'wedding-services-gibraltar';
  return `${base}-gibraltar`;
};

export const categoryNameToSeoPath = (categoryName) => `/${categoryNameToSeoSlug(categoryName)}`;

export const resolveCategoryNameFromSeoSlug = (seoSlug, categories) => {
  if (!seoSlug || !String(seoSlug).endsWith('-gibraltar')) return null;

  const normalizedSlugBase = normalizeCategoryBase(String(seoSlug).replace(/-gibraltar$/, ''));
  if (!normalizedSlugBase) return null;

  const categoryNames = (categories || [])
    .map((category) => (typeof category === 'string' ? category : category?.name))
    .filter(Boolean);

  const match = categoryNames.find((name) => normalizeCategoryBase(name) === normalizedSlugBase);
  if (match) return match;

  const stopWords = new Set(['wedding', 'gibraltar', 'and', 'the', 'in']);
  const slugTokens = normalizedSlugBase.split('-').filter((token) => token && !stopWords.has(token));

  const fuzzyMatch = categoryNames.find((name) => {
    const categoryTokens = normalizeCategoryBase(name)
      .split('-')
      .filter((token) => token && !stopWords.has(token));

    return slugTokens.length > 0 && slugTokens.every((token) => categoryTokens.includes(token));
  });

  return fuzzyMatch || null;
};

export const formatWeddingCategoryLabel = (categoryName) => {
  const cleaned = String(categoryName || '').trim().replace(/\s+/g, ' ');
  if (!cleaned) return 'Wedding Services';
  return /^wedding\s+/i.test(cleaned) ? cleaned.replace(/^wedding\s+/i, '').trim() : cleaned;
};
